import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class AdminService {
  constructor(private api: ApiService) {}

  getWrappedDocument(token: string) {
    return this.api.get(`v1/wrapped/${token}`);
  }
}
